/* eslint-disable */

// source-map-js shim for browser compatibility
// This module is used for source map processing but not needed in browser runtime

export class SourceMapConsumer {
    constructor() {}
    static fromSourceMap() { return new SourceMapConsumer(); }
    destroy() {}
    originalPositionFor() { return { source: null, line: null, column: null, name: null }; }
    generatedPositionFor() { return { line: null, column: null }; }
    eachMapping() {}
    allGeneratedPositionsFor() { return []; }
    hasContentsOfAllSources() { return false; }
    sourceContentFor() { return null; }
    computeColumnSpans() {}
}

export class SourceMapGenerator {
    constructor() {}
    static fromSourceMap() { return new SourceMapGenerator(); }
    addMapping() {}
    setSourceContent() {}
    applySourceMap() {}
    toString() { return '{}'; }
    toJSON() { return {}; }
}

export class SourceNode {
    constructor() {}
    static fromStringWithSourceMap() { return new SourceNode(); }
    add() { return this; }
    prepend() { return this; }
    setSourceContent() {}
    walk() {}
    join() { return this; }
    replaceRight() { return this; }
    toString() { return ''; }
    toStringWithSourceMap() { return { code: '', map: new SourceMapGenerator() }; }
}

export default {
    SourceMapConsumer,
    SourceMapGenerator,
    SourceNode,
};
